import React, { Fragment, useState, useContext} from "react";
import {useQueryClient} from "react-query";
import { makeStyles } from "@material-ui/core/styles";
import {Icon, Tooltip, useTheme} from "@material-ui/core";
import dayjs from "dayjs";
import __ from "lodash";
import utc from "dayjs/plugin/utc";
import MxToolTipStyles from "./MxToolTipStyles";
import { useAirports } from "../../services/airports";
import IconButtonMenu from "../IconButtonMenu";
import SystemContext from "../../SystemContext";

dayjs.extend(utc)

const AirportData = (props) => {
  const queryClient = useQueryClient();

  const airport = useAirports({queryClient, extraKeys:[props.airportCode], useCache: true});

  return (<div style={props.style}>{airport.data?airport.data[0][props.field]:props.airportCode}</div>)
}

const ContextMenu = (props) => {
  const theme = useTheme();
  const {mxData} = props;

  const menuItems = [];
  if (mxData.changed) {
    menuItems.push({action: "undo", itemLabel:"Undo" ,itemIcon: (<Icon>undo</Icon>)});
  }

  return (
    <IconButtonMenu
      style={{ color: theme.palette.primary.main }}
      hidden={false}
      size={"small"}
      offset={-1}
      tooltip={"Actions"}    
      icon={(<Icon>menu</Icon>)}
      menuItems={menuItems}
      zIndex={1500}
      callback={props.callback}
      callbackParams={{mxData}}
  />

  )

}

const MxTooltip = (props) => {

  const { data: mxData, editing } = props;
  const classes = makeStyles(MxToolTipStyles)();

  const [toolTipText, setToolTipText] = useState("");
  const [opened, setOpened] = useState(false);

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  let statusColor = "rgb(215,0,0)";

  let displayStatus = mxData.status;
  if (mxData.aircraftCheck === 'AOG') {
    if (mxData.status !== "RECOVERED") {
      displayStatus = 'ONGOING';
    } else {
      statusColor = "rgb(31,216,21)";   
    }
  } else {
    if (mxData.status === "CONFIRMED") statusColor = "rgb(31,216,21)";
  }

  const handleMenuAction = (params) => {
    const {selectedAction, mxData, extraData} = params;
    if (__.isString(selectedAction)) {
      eventBus.trigger(`RouteView.TimeWindow.MxAction.${selectedAction}`, {mxData, extraData});
    }
  }

  const openToolTip = () => {
    if (!opened) {
      console.log('opening');
      setOpened(true);
      if (mxData) {
        setToolTipText(
          <Fragment>
            {editing ?(
              <div style={{position: "absolute"}}>
                <ContextMenu
                  callback={handleMenuAction}
                  mxData={mxData}
                />
              </div>
            ):null}            

            {mxData.aircraftCheck === 'AOG'
            ? (
              <div style={{ textAlign: "center", fontSize: 24, fontWeight: "bold", padding: 8}}>AOG</div>
            ): null}
            <div style={{ textAlign: "center", fontSize: 24, fontWeight: "bold", padding: 8, lineHeight: 1}}>{mxData.mxAircraftCheckInfo}</div>
            <div style={{ padding: 10, textAlign: "center"}}>
              <div style={{width: 280, display: "inline-block", border: "0px solid #ffffff", textAlign: "center"}}>
                <div>
                    <div style={{display: "inline-block", fontSize: 20, fontWeight: "bold", padding: 8}}>{mxData.mxAirportCode}</div>
                    <div style={{display: "inline-block", fontSize: 20, fontWeight: "bold", padding: 6}}><AirportData airportCode={mxData.mxAirportCode} field='icaoCode'/></div>
                </div>
                <div style={{ padding: 10, paddingTop: 0, textAlign: "center"}}>
                    <AirportData
                        style={{fontSize: 12, padding: 4, paddingBottom: 2, width: "100%"}}
                        airportCode={mxData.mxAirportCode}
                        field='airportName'
                    />
                </div>
              </div>
              <div>
                <div style={{width: 140, display: "inline-block",fontSize: 16, fontWeight: "bold", padding: 6}}>{dayjs(mxData.startCheckDate).utc().format('DD MMM HH:mm')}</div>
                <div style={{width: 140, display: "inline-block",fontSize: 16, fontWeight: "bold", padding: 6}}>{dayjs(mxData.endCheckDate).utc().format('DD MMM HH:mm')}</div>
              </div>
              {mxData.notes && mxData.aircraftCheck !== 'AOG' && mxData.aircraftCheck !== 'TEC' &&
                <div style={{whiteSpace: "preserve", fontSize: 12, fontWeight: "bold", padding: 8, width: 280, maxWidth: 280, maxHeight: 200, display: "block", border: "2px solid #ffffff", textAlign: "left", overflowY: "scroll", textOverflow: "wrap"}}>
                  {mxData.notes}
                </div>
              }
              <div style={{marginTop: 10, fontSize: 24, fontWeight: "bold", padding: 8, width: 280, display: "block", border: "2px solid #ffffff", textAlign: "center", backgroundColor: statusColor}}>
                {displayStatus}
              </div>
              {(mxData.aircraftCheck === 'AOG' && mxData.aogActivities && (
                (mxData.aogActivities.nextUpdate && mxData.status !== 'RECOVERED') || 
                (mxData.aogActivities && Array.isArray(mxData.aogActivities.activity) && mxData.aogActivities.activity.length > 0)
              ))
              ? (
                <div style={{fontSize: 12, fontWeight: "bold", padding: 8, width: 280, display: "block", border: "2px solid #ffffff", textAlign: "left", backgroundColor: statusColor}}>
                  {(Array.isArray(mxData.aogActivities.activity) && mxData.aogActivities.activity.length > 0)
                  ? (
                    <div>
                      <div style={{fontSize: 14, fontWeight: "bold", paddingBottom: 4}}>
                        Latest Status:
                      </div>
                      <div  style={{fontSize: 12}}>
                        {mxData.aogActivities.activity[0].details}
                      </div>
                    </div>
                  )
                  : null}
                  {(mxData.aogActivities.nextUpdate && mxData.status !== 'RECOVERED') 
                  ? (
                    <>
                    <div style={{height: 8, display: "block",fontSize: 14, fontWeight: "bold"}}>&nbsp;</div>
                    <div style={{width: 90, display: "inline-block",fontSize: 14, fontWeight: "bold"}}>Next Update:</div>
                    <div style={{width: 136, display: "inline-block",fontSize: 14, fontWeight: "bold"}}>{mxData.aogActivities.nextUpdate}</div>
                    </>
                  ) : null}
                </div>
              ) : null}
            </div>
          </Fragment >
        );
      }
    }
  }

  const popperRef = React.useRef(null);

  return (
    <Tooltip onOpen={openToolTip} onClose={props.onClose} arrow interactive 
      leaveDelay={300}
      classes={{ tooltip: classes.tripTooltip }} 
      placement="top"
      title={toolTipText}
      PopperProps={{
        popperRef,
        anchorEl: {
          getBoundingClientRect: () => {
            return new DOMRect(
              props.position.x,
              props.position.y,
              0,
              24,
            );
          },
        },
      }}
    >
      {props.children}
    </Tooltip>
  );
}

export default MxTooltip;